/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:52
 * @LastEditTime: 2023-11-29 19:00:51
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/store/state.js
 */
// 数据
// path: store/state.js
const state = {
  tenant: JSON.parse(localStorage.getItem('tenant')) || '', // 门店信息
  xxx: '',
  listDatas: JSON.parse(localStorage.getItem('listData')) || [],
  overall: JSON.parse(localStorage.getItem('overall')) || '',
  permissionlist: [],
  navindex: localStorage.getItem('navindex') || 0, // 全局一级菜单
  childIndex: localStorage.getItem('childIndex') || 0,
  isActive_second: localStorage.getItem('isActive_second') || 0, // 全局二级菜单
  goodsTypeOptions: [], // 项目类别数据
  productTypeOptions: [], // 产品类别数据
  memberLevelOptions: [], // 会员等级分类
  memberSourceOptions: [], // 会员来源分类
  serverTime: JSON.parse(localStorage.getItem('serverTime')) || new Date(), // 后端服务器时间
  searchHistoryList: JSON.parse(localStorage.getItem('searchHistoryListsOne')) || [] // 会员搜索历史
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js